import React from 'react'
import { connect } from 'react-redux'
import WyborWariantuRZiS from '../../components/RZiS/WyborWariantuRZiS'
import Zestawienie from '../../components/Zestawienie/Zestawienie'
import ZestawienieHeader from '../../components/Zestawienie/ZestawienieHeader'
import ZestawienieName from '../../components/Zestawienie/ZestawienieName'
import {
  formulyInnaRZiSKalkulacyjny,
  formulyInnaRZiSPorownawczy,
  formulyMalaRZiSKalkulacyjny,
  formulyMalaRZiSPorownawczy,
  formulyMikroRZiS_v1,
  formulyMikroRZiS_v2,
  formulyOpRZiS,
  formulyRZiSDomMaklerski,
  formulySkonsolidowanyRZiSKalkulacyjny,
  formulySkonsolidowanyRZiSPorownawczy,
} from '../../lib/formulas'
import zaokragl from '../../lib/mathUtils'
import { czyKwotyWTysiacach, dajStrukture } from '../../lib/structureChecker'
import * as actions from '../../store/actions'
import BilansStyle from '../../styles/BilansStyle'
import ImportCSVInfo from '../../components/Zestawienie/ImportCSVInfo'
import InfoPanel from '../../components/InfoPanel'

export class RZiS extends React.Component {
  isValueInThirdColumn = () => {
    return this.props.section.Dane.Pozycje.some((i) => i.KwotaB1 !== 0)
  }

  state = { isThirdColumn: this.isValueInThirdColumn(), czyszczenie: false }

  setIsThirdColumn = (v) => {
    this.setState({ isThirdColumn: v })
  }

  sumValues = (value, changedIndex, name, parts, pozycje) => {
    let partsSum = 0

    parts.forEach((x) => {
      let i = Math.abs(x)
      if (!pozycje[i].Widoczny) return
      if (x < 0) {
        partsSum = zaokragl(
          partsSum - (i === changedIndex ? value : pozycje[i][name]),
        )
      } else
        partsSum = zaokragl(
          partsSum + (x === changedIndex ? value : pozycje[x][name]),
        )
    })
    return partsSum
  }

  czySekcjaFwJednostceMikro = (pozycje) =>
    pozycje.some((value) => value.Numer.indexOf('F') !== -1)

  dajFormuly = (pozycje, wariantIndex) => {
    const struktura = this.props.section.Dane.Struktury[wariantIndex]
    switch (struktura) {
      case 'RZISInnaPorownawczy':
      case 'RZISInnaPorownawczy_v1_3':
          return formulyInnaRZiSPorownawczy
      case 'RZISInnaKalkulacyjny':  
      case 'RZISInnaKalkulacyjny_v1_3':  
        return formulyInnaRZiSKalkulacyjny
      case 'RZISMikro':
        if (this.czySekcjaFwJednostceMikro(pozycje)) return formulyMikroRZiS_v1
        else return formulyMikroRZiS_v2
      case 'RZISMikro_v1_3':
        return formulyMikroRZiS_v1
      case 'RZISMalaKalkulacyjny':
      case 'RZISMalaKalkulacyjny_v1_3':        
          return formulyMalaRZiSKalkulacyjny
      case 'RZISMalaPorownawczy':
      case 'RZISMalaPorownawczy_v1_3':        
          return formulyMalaRZiSPorownawczy
      case 'RZISOP':
      case 'RZISOP_v1_3':
        return formulyOpRZiS
      case 'RZISDomMaklerski':
        return formulyRZiSDomMaklerski
      case 'RZISSkonsolidowanyKalkulacyjny':
      case 'RZISSkonsolidowanyKalkulacyjny_v1_3':
          return formulySkonsolidowanyRZiSKalkulacyjny
      case 'RZISSkonsolidowanyPorownawczy':
      case 'RZISSkonsolidowanyPorownawczy_v1_3':        
        return formulySkonsolidowanyRZiSPorownawczy
      default:
        return null
    }
  }

  aktualizujSumy = (value, index, name, pozycje, indexOffset, wariantIndex) => {
    if (this.state.czyszczenie) return
    if (!value) value = 0
    const { onSetSectionDataArray } = this.props
    let formuly = this.dajFormuly(pozycje, wariantIndex)
    onSetSectionDataArray(value, index + indexOffset, name)
    if (formuly && name !== 'Nazwa')
      formuly.forEach((x) => {
        let suma = this.sumValues(value, index, name, x.polaSkladowe, pozycje)
        if (!x.warunek)
          onSetSectionDataArray(suma, x.poleSumy + indexOffset, name)
        else if (x.warunek) {
          if (x.warunek(suma))
            onSetSectionDataArray(suma, x.poleSumy + indexOffset, name)
          else onSetSectionDataArray(0, x.poleSumy + indexOffset, name)
        }
      })
  }

  czyszczenie = async () => {
    this.setState({ czyszczenie: true })
    await this.props.onClearTable('Pozycje')
    await this.setState({ czyszczenie: false })
  }

  render() {
    const {
      czyKwotyWTysiacach,
      onSetSectionData,
      section,
      onImportCSV,
      id,
    } = this.props
    const wariant = section.Dane.Wariant
    const dostepneWarianty = section.Dane.DostepneWarianty
    const opisWariantu = dajOpisWariantu(section)
    const pozycje = dajPozycje(section)
    return (
      <>
        <InfoPanel rolledContent={ImportCSVInfo} />
        <BilansStyle>
          <ZestawienieName
            name={`RACHUNEK ZYSKÓW I STRAT${
              opisWariantu ? ' - ' + opisWariantu : ''
            }`}
            onImport={(file) => onImportCSV(id, this.props.section, file)}
            onClear={this.czyszczenie}
          />
          <WyborWariantuRZiS
            dostepneWarianty={dostepneWarianty}
            wariant={wariant}
            zmienWariant={(wariant) => {
              onSetSectionData('Wariant', wariant, 0)
            }}
          />
          <ZestawienieHeader
            isThirdColumn={this.state.isThirdColumn}
            onCheck={(e) => this.setIsThirdColumn(e.target.checked)}
          />
          <div className="container rzis">
            {dostepneWarianty && dostepneWarianty.length > 0 ? (
              dostepneWarianty.map((element, wariantIndex) => {
                return (
                  wariant === wariantIndex && (
                    <Zestawienie
                      key={wariantIndex}
                      onSetSectionDataArray={(value, index, name) =>
                        this.aktualizujSumy(
                          value,
                          index,
                          name,
                          pozycje[wariantIndex],
                          wariantIndex === 0
                            ? 0
                            : pozycje[wariantIndex - 1].length,
                          wariantIndex,
                        )
                      }
                      isThirdColumn={this.state.isThirdColumn}
                      dane={pozycje[wariantIndex]}
                      czyKwotyWTysiacach={czyKwotyWTysiacach}
                    />
                  )
                )
              })
            ) : (
              <Zestawienie
                onSetSectionDataArray={(value, index, name) =>
                  this.aktualizujSumy(value, index, name, pozycje[0], 0, 0)
                }
                dane={pozycje[0]}
                isThirdColumn={this.state.isThirdColumn}
                czyKwotyWTysiacach={czyKwotyWTysiacach}
              />
            )}
          </div>
        </BilansStyle>
      </>
    )
  }
}

const dajOpisWariantu = (section) => {
  const { DostepneWarianty, Wariant } = section.Dane
  return DostepneWarianty && DostepneWarianty.length > 0
    ? DostepneWarianty[Wariant]
    : ''
}

const dajPozycje = (section) => {
  const { Pozycje, DostepneWarianty } = section.Dane
  let wynik = [Pozycje]
  if (DostepneWarianty && DostepneWarianty.length > 1) {
    wynik = DostepneWarianty.map((el, index) => {
      return Pozycje.filter((item) => {
        return item.Wariant === index
      })
    })
  }
  return wynik
}

const mapStateToProps = (state) => ({
  czyKwotyWTysiacach: czyKwotyWTysiacach(state.sprawozdanie.header),
  struktura: dajStrukture(state.sprawozdanie.header),
  id: state.sprawozdanie.header.Id,
})

const mapDispatchToProps = (dispatch) => ({
  onSetSectionData: (name, value, index) => {
    dispatch(actions.setSectionData(name, value, index))
  },
  onSetSectionDataArray: (value, index, name) => {
    dispatch(actions.setSectionDataArray(value, index, 0, name))
  },
  onImportCSV: (id, section, file) => {
    dispatch(actions.importCSV(id, section, file))
  },
  onClearTable: (array) => dispatch(actions.clearTable(array)),
})

export default connect(mapStateToProps, mapDispatchToProps)(RZiS)
